import { Container } from "components/landing/feature-grid"
import Shimmer from "components/ui/shimmer"
import useWindowDimensions from "helpers/window-dimensions"

const FeatureGridSkeleton = () => {
  const { isMobile } = useWindowDimensions()
  return (
    <div className="widescreen:py-60 py-32">
      <Container containWide>
        {[...Array(4)].map((_, index) => (
          <Shimmer
            className="w-full"
            key={`feature-grid-skeleton-${index}`}
            style={{
              aspectRatio: isMobile ? "368 / 516" : "1024 / 1435",
            }}
          />
        ))}
      </Container>
    </div>
  )
}

export default FeatureGridSkeleton
